<template>
  <Disclosure
    class="tw-w-full tw-rounded-xl tw-border tw-border-neutral-900 tw-bg-neutral-800"
  >
    <template #activator="{ toggle, isActive, ariaExpanded, ariaControls }">
      <button
        @click="toggle"
        class="tw-w-full tw-p-4"
        :aria-expanded="ariaExpanded"
        :aria-controls="ariaControls"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-space-x-4">
          <div class="tw-flex tw-items-center tw-space-x-4">
            <div
              class="tw-flex tw-h-14 tw-w-14 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full"
              :style="{
                background: `conic-gradient(#4AC074 ${progressInPercent}%, 0, #4e5b6d ${
                  100 - progressInPercent
                }%)`,
              }"
            >
              <div
                class="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-neutral-800 tw-text-sm tw-text-neutral-300"
              >
                {{ progressInPercent }}%
              </div>
            </div>
            <div class="tw-space-y-1 tw-text-left">
              <div class="tw-text-sm tw-text-neutral-300">
                Complete your profile to activate your account
              </div>
              <div
                v-if="firstItemToComplete"
                class="tw-font-semibold tw-text-white"
              >
                {{ firstItemToComplete.description }}
              </div>
            </div>
          </div>

          <ArrowDownIcon
            class="tw-h-4 tw-w-4 tw-shrink-0 tw-text-neutral-400 tw-transition-transform tw-duration-300"
            :class="{ 'tw-rotate-180': isActive }"
          />
        </div>
      </button>
    </template>
    <template #content="{ id }">
      <div
        :id="id"
        class="tw-space-y-2 tw-border-t tw-border-neutral-700 tw-p-4 tw-text-neutral-500"
      >
        <component
          v-for="(element, index) in mergedProfileCompletion"
          :key="index"
          :is="element.status ? 'div' : 'InertiaLink'"
          :href="element.href"
          class="tw-flex tw-items-center tw-text-sm sm:tw-text-base"
          :class="{ 'tw-font-semibold tw-text-white': !element.status }"
        >
          <CheckIcon
            class="tw-mr-4 tw-h-4 tw-w-4"
            :class="[
              element.status ? 'tw-text-success-300' : 'tw-text-neutral-500',
            ]"
          />
          {{ element.description }}
          <TriangleRight
            v-if="!element.status"
            class="tw-ml-2 tw-h-3 tw-w-3 tw-text-neutral-500"
          />
        </component>
      </div>
    </template>
  </Disclosure>
</template>

<script setup>
import ArrowDownIcon from '@/assets/images/icons/arrow-down.svg'
import CheckIcon from '@/assets/images/icons/check.svg'
import TriangleRight from '@/assets/images/icons/arrow-right.svg'
import Disclosure from '@/shared/components/Disclosure.vue'
import { useUserProfileCompletion } from '@/shared/composables/useUserProfileCompletion.js'

const { firstItemToComplete, mergedProfileCompletion, progressInPercent } =
  useUserProfileCompletion()
</script>
